module.exports = __webpack_public_path__ + "static/img/IMG_0908.ee84b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0908.jpg
// module id = EtEh
// module chunks = 12